"use strict";

import warnAboutDeprecatedESMImport from "./warnAboutDeprecatedESMImport.js";
warnAboutDeprecatedESMImport("Switch");
import { Switch } from "../esm/react-router.js";
export default Switch;